//Ferti Table
export const rowsNum = 10;
export const productsForPhase = 6;
export const lineSpeed = 2.5;
export const pipeSpeed = 1.5;
export const rowsBasicNum = 10;
